export default __webpack_public_path__ + "static/media/co3.aef8c2d8.png";